import { render, staticRenderFns } from "./BulkMessageModal.vue?vue&type=template&id=5890c576&scoped=true"
import script from "./BulkMessageModal.vue?vue&type=script&lang=js"
export * from "./BulkMessageModal.vue?vue&type=script&lang=js"
import style0 from "./BulkMessageModal.vue?vue&type=style&index=0&id=5890c576&prod&lang=scss&scoped=true"
import style1 from "./BulkMessageModal.vue?vue&type=style&index=1&id=5890c576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5890c576",
  null
  
)

export default component.exports